var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"providers-page d-flex flex-column flex-strectch"},[_c('app-navbar',{attrs:{"inverted":"true"}}),_vm._v(" "),_c('app-best-providers',{attrs:{"hoverable":"true"}}),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3348ef52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/Providers/providers.html
// module id = null
// module chunks = 